import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import OfferingModal from './OfferingModal';
import { pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import ReceiptDocument from './ReceiptDocument'; // 👈 Import component


import ReceiptModal from './ReceiptModal';
import { getDecryptedUserFromCookie } from './utils/getCookie';
import { decryptToken } from './utils/getToken';

const Receipt = () => {
  const [customers, setCustomers] = useState([]);

  const today = new Date().toISOString().split("T")[0];
  const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");


  // State Variables
  const [searchQuery, setSearchQuery] = useState('');
  const { isSidebarOpen } = useSidebar();
  const [filteredCustomers, setFilteredCustomers] = useState(customers);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [totalReceivedAmount, setTotalReceivedAmount] = useState(0);


  const [editData, setEditData] = useState(null);
  const [invoices, setInvoices] = useState([]);
  const urlad = process.env.REACT_APP_LINKADMIN
  const url = process.env.REACT_APP_LINK;
  const token = decryptToken("accessToken") || ""

  const fetchInvoices = async () => {
    try {
      const res = await fetch(`${url}/newinvoice/all/${isLoggedIn.main_id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      const data = await res.json();

      if (Array.isArray(data)) {
        const sortedInvoices = data.sort((a, b) => b.order_number - a.order_number); // most recent first
        setInvoices(sortedInvoices);
      } else {
        console.warn("Unexpected response format:", data);
        setInvoices([]);
      }
    } catch (error) {
      console.error("Failed to fetch invoices:", error);
      setInvoices([]);
    }
  };
  useEffect(() => {


    fetchInvoices();
  }, []);


  // Effect to handle filtering
  useEffect(() => {
    const filtered = customers.filter((customer) =>
      Object.values(customer).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
    setFilteredCustomers(filtered);
    setCurrentPage(1); // Reset to first page on new search
  }, [searchQuery, customers]);

  // Pagination Logic
  const totalPages = Math.ceil(filteredCustomers.length / itemsPerPage);
  const currentData = filteredCustomers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Handlers
  const handleSearch = (e) => setSearchQuery(e.target.value);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Handle Delete
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this receipt?")) return;

    try {
      const res = await fetch(`${url}/receipt/${id}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });

      if (res.ok) {
        alert('Receipt deleted successfully');
        fetchReceipts(); // ✅ Refresh the list
      } else {
        alert('Failed to delete receipt');
      }
    } catch (err) {
      console.error('Error deleting receipt:', err);
      alert('An error occurred while deleting the receipt.');
    }
  };


  const fetchReceipts = async () => {
    try {
      const user = getDecryptedUserFromCookie("gta_mainstateuser");
      const res = await fetch(`${url}/receipt/${user.main_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      const data = await res.json();
      setCustomers(data.reverse()); // Show latest receipts first

      const total = data.reduce((acc, curr) => acc + parseFloat(curr.amount || 0), 0);
      setTotalReceivedAmount(total);
    } catch (err) {
      console.error("Error fetching receipts:", err);
    }
  };

  // ✅ Call fetchReceipts on mount
  useEffect(() => {
    fetchReceipts();
  }, []);

  const getStatus = (invoice) => {
    const today = new Date().toISOString().split("T")[0];
    const dueDate = invoice.due_date;
    const pending = parseFloat(invoice.pending) || 0;

    if (pending === 0) return { label: "Paid", color: "green" };
    if (dueDate < today) return { label: "Overdue", color: "red" };
    return { label: "Pending", color: "gray" };
  };

  const dueTodayPendingTotal = invoices.reduce((acc, invoice) => {
    const dueDate = new Date(invoice.due_date);
    if (isNaN(dueDate)) return acc; // ✅ Skip if date is invalid

    const formattedDueDate = dueDate.toISOString().split("T")[0];
    return formattedDueDate === today ? acc + (parseFloat(invoice.pending) || 0) : acc;
  }, 0);

  const overduePendingTotal = invoices.reduce((acc, invoice) => {
    if (invoice.dpstatus === "Draft") return acc;
    const { label } = getStatus(invoice);
    return label === "Overdue" ? acc + (parseFloat(invoice.pending) || 0) : acc;
  }, 0);

  const toBase64 = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };


  const payableWithin30DaysTotal = invoices.reduce((acc, invoice) => {
    if (invoice.dpstatus === "Draft") return acc;

    const dueDate = new Date(invoice.due_date);
    if (isNaN(dueDate)) return acc; // ✅ Validate date

    const today = new Date();
    const diffInDays = (dueDate - today) / (1000 * 60 * 60 * 24);

    if (diffInDays > 0 && diffInDays <= 30) {
      const balanceDue = invoice.adjusted_pending !== undefined
        ? parseFloat(invoice.adjusted_pending)
        : parseFloat(invoice.pending) || 0;
      return acc + balanceDue;
    }

    return acc;
  }, 0);

  console.log(invoices)
  const downloadReceiptPDF = async (receipt) => {
    try {
      const user = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || {};
      const profileRes = await fetch(`${url}/register/single/${user.main_id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      const profile = await profileRes.json();
      const profileData = profile.users
      // const settingsRes = await fetch(`${url}/setting/info?user=${isLoggedIn.mobile}`);
      // const settingsData = await settingsRes.json();

      profileData.address = profileData.office_address || "...";
      profileData.phone = profileData.mobile || "8433 803 555";
      profileData.email = profileData.email || "";
      profileData.logo = profileData.logo
      const invoice = invoices.find(inv => inv.invoice_number === receipt.invoiceNumber);
      console.log("🧾 Invoice passed to ReceiptDocument:", invoice);
      console.log(invoice)

      let base64Logo = null;
      if (profileData?.profilePic) {
        const imageUrl = `${url}/logo/${profileData.profilePic}`;
        try {
          base64Logo = await toBase64(imageUrl);
        } catch (error) {
          console.warn("Logo conversion failed:", error);
          base64Logo = "https://100billiontech.com/static/media/100BILLION_TECH_name.aad194ea6504959b3f99.png"; // optional
        }
      }
      // const blob = await pdf(
      //   <InvoiceDocument invoice={invoice} profile={profileData} logoBase64={base64Logo} />
      // ).toBlob();
      // saveAs(blob, `Invoice_${invoice.invoice_number}.pdf`);

      const blob = await pdf(
        <ReceiptDocument
          receipt={receipt}
          profile={profileData}
          invoice={invoice}
          logoBase64={base64Logo}
        />
      ).toBlob();

      saveAs(blob, `Receipt_${receipt.invoiceNumber}_${receipt.receiptDate}.pdf`);
    } catch (err) {
      console.error("Error generating receipt PDF:", err);
    }
  };





  const viewReceiptPDF = async (receipt) => {
    console.log(receipt)
    try {
      const user = getDecryptedUserFromCookie("gta_mainstateuser");
      const profileRes = await fetch(`${url}/register/single/${user.main_id}`, {
        method:"GET",
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      const profile = await profileRes.json();
      const profileData = profile.users

      profileData.address = profileData.office_address || "...";
      profileData.phone = profileData.mobile || "";
      profileData.email = profileData.email || "";
      profileData.logo = profileData.logo
      profileData.orignal_logoname = profileData.orignal_logoname
      const invoice = invoices.find(inv => inv.invoice_number === receipt.invoiceNumber);
      console.log("🧾 Invoice passed to ReceiptDocument:", invoice);
      console.log(receipt)


      let base64Logo = null;
      if (profileData?.profilePic) {
        const imageUrl = `${url}/logo/${profileData.profilePic}`;
        try {
          base64Logo = await toBase64(imageUrl);
        } catch (error) {
          console.warn("Logo conversion failed:", error);
          base64Logo = "https://100billiontech.com/static/media/100BILLION_TECH_name.aad194ea6504959b3f99.png"; // optional
        }
      }
      const blob = await pdf(
        <ReceiptDocument
          receipt={receipt}
          profile={profileData}
          invoice={invoice}
          logoBase64={base64Logo}
        />
      ).toBlob();
      const fileURL = URL.createObjectURL(blob);
      window.open(fileURL, "_blank");
      // saveAs(blob, `Invoice_${invoice.invoice_number}.pdf`);

      // const blob = await pdf(
      //   <ReceiptDocument
      //     receipt={receipt}
      //     profile={profileData}
      //     invoice={invoice}
      //   />
      // ).toBlob();


    } catch (err) {
      console.error("Error viewing receipt PDF:", err);
    }
  };








  return (
    <>

      <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
        <div className="oms-header">
          <h1 className="dashboard-title">Receipts</h1>

          {/* Add Offers Button */}
          <button className="oms-add-btn" onClick={() => setIsModalOpen(true)}>
            Create Receipt
          </button>
        </div>

        <div className="payment-summary">
          <p className="payment-head">
            Receipts Summary
          </p>
          <div className="payment-summary-details">
            <div className="payment-summary-list list1">
              <i className="fa-solid fa-arrow-down"></i>
              <div className="details">
                <p className="label">Total amount received</p>
                <h3>Rs. {totalReceivedAmount.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</h3>

              </div>
            </div>

            <div className="payment-summary-list list2">
              <div className="payment">
                <p className="label">Due as of today</p>
                <h3>Rs. {Number(dueTodayPendingTotal).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</h3>

              </div>

              <div className="payment">
                <p className="label">Payable within 30 days</p>
                <h3>Rs. {payableWithin30DaysTotal.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</h3>
              </div>

              <div className="payment">
                <p className="label">Overdue Payment</p>
                <h3>Rs. {overduePendingTotal.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</h3>
              </div>

              {/* <div className="payment">
                                <p className="label">Average payment cycle</p>
                                <h3>₹800.28</h3>
                            </div> */}
            </div>
          </div>
        </div>

        {/* Search Filter */}
        <div className="filter-search">
          <div className="filter-search-input">
            <input
              type="search"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearch}
            />
            <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
          </div>
        </div>

        {/* Customer Table */}
        <div className="customer-table">
          <table>
            <thead>
              <tr>
                <th>Receipt Date</th>
                <th>Customer Name</th>
                <th>Invoice Number</th>
                <th>Amount</th>
                <th>Receipt</th>

                {/* <th>Send Mail</th> */}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentData.length > 0 ? (
                currentData.map((receipt, index) => (
                  <tr key={index}>
                    <td>{receipt.receiptDate}</td>
                    <td>{receipt.customerName}</td>
                    <td>{receipt.invoiceNumber}</td>
                    <td>{receipt.amount}</td>
                    <td>
                      <button onClick={() => downloadReceiptPDF(receipt)}>
                        <i className="fa-solid fa-download"></i>
                      </button>
                      <button onClick={() => viewReceiptPDF(receipt)} style={{ marginLeft: '8px' }}>
                        <i className="fa-solid fa-eye"></i>
                      </button>

                    </td>


                    {/* <td>{receipt.sendMail ? "Yes" : "No"}</td> */}
                    <td>
                      <button className="edit-btn" onClick={() => {
                        setEditData(receipt);
                        setIsModalOpen(true);
                      }}>
                        <i className="fa-solid fa-pen"></i>
                      </button>
                      <button
                        className="delete-btn"
                        style={{ marginLeft: '8px' }}
                        onClick={() => handleDelete(receipt.id)} // 👈 pass specific id
                      >
                        <i className="fa-solid fa-trash"></i>
                      </button>

                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" style={{ textAlign: 'center' }}>No data found.</td>
                </tr>
              )}
            </tbody>



          </table>
        </div>


        {/* Pagination */}
        <div className="pagination">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index}
              onClick={() => paginate(index + 1)}
              className={currentPage === index + 1 ? 'active' : ''}
            >
              {index + 1}
            </button>
          ))}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </div>

      <ReceiptModal
        isOpen={isModalOpen}
        setIsOpen={(val) => {
          setIsModalOpen(val);
          if (!val) setEditData(null);
        }}
        editData={editData}
        fetchReceipts={fetchReceipts}
        fetchInvoices={fetchInvoices}
      />

    </>
  );
};

export default Receipt;
